// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/backoffice/service/decision/v1/decision.proto (package gdx.backoffice.service.decision.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Outcome is the moderation decision: "approved" (the item can be published on the site),
 * "refused" (the item should not be published on the site).
 *
 * @generated from enum gdx.backoffice.service.decision.v1.Outcome
 */
export enum Outcome {
  /**
   * @generated from enum value: OUTCOME_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: OUTCOME_REFUSED = 1;
   */
  REFUSED = 1,

  /**
   * @generated from enum value: OUTCOME_APPROVED = 2;
   */
  APPROVED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Outcome)
proto3.util.setEnumType(Outcome, "gdx.backoffice.service.decision.v1.Outcome", [
  { no: 0, name: "OUTCOME_INVALID" },
  { no: 1, name: "OUTCOME_REFUSED" },
  { no: 2, name: "OUTCOME_APPROVED" },
]);

/**
 * Reason contains the reason why the item was refused. It is only present when outcome is "refused".
 *
 * @generated from message gdx.backoffice.service.decision.v1.Reason
 */
export class Reason extends Message<Reason> {
  /**
   * @generated from field: string comment = 1;
   */
  comment = "";

  constructor(data?: PartialMessage<Reason>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.service.decision.v1.Reason";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Reason {
    return new Reason().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Reason {
    return new Reason().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Reason {
    return new Reason().fromJsonString(jsonString, options);
  }

  static equals(a: Reason | PlainMessage<Reason> | undefined, b: Reason | PlainMessage<Reason> | undefined): boolean {
    return proto3.util.equals(Reason, a, b);
  }
}

/**
 * Feedback contains optional feedback, allowing for instructions on what to fix or improve to be given to the user.
 *
 * @generated from message gdx.backoffice.service.decision.v1.Feedback
 */
export class Feedback extends Message<Feedback> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  constructor(data?: PartialMessage<Feedback>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.service.decision.v1.Feedback";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Feedback {
    return new Feedback().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Feedback {
    return new Feedback().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Feedback {
    return new Feedback().fromJsonString(jsonString, options);
  }

  static equals(a: Feedback | PlainMessage<Feedback> | undefined, b: Feedback | PlainMessage<Feedback> | undefined): boolean {
    return proto3.util.equals(Feedback, a, b);
  }
}

